import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import day from './day.js'
import dropdown from './dropdown.js'
import month from './month.js'
import nav from './nav.js'
import today from './today.js'
import view from './view.js'
import year from './year.js'

export default contract({
  day: array([
    day
  ]),
  dropdown: array([
    dropdown
  ]),
  month: array([
    month
  ]),
  nav: array([
    nav
  ]),
  today: array([
    today
  ]),
  view: array([
    view
  ]),
  year: array([
    year
  ])
})
